import { BubbleDataPoint, ChartDataset, ChartTypeRegistry, Plugin, Point } from 'chart.js'
import { formatCurrency } from '../../format-currency'
import { formatTasks } from '../../format-tasks'
import { MAP_LOGO_BY_PROVIDER } from '../../../../../../components/__common/map-logo-by-provider'
import { ProviderName } from '@indigohive/cogfy-providers'

const getOrCreateLegendList = (_chart: any, id: string) => {
  const legendContainer = document.getElementById(id)
  let listContainer = legendContainer?.querySelector('ul')

  if (!listContainer) {
    listContainer = document.createElement('ul')
    listContainer.className = 'flex flex-col gap-2 m-0 p-0 overflow-hidden '

    legendContainer?.appendChild(listContainer)
  }

  return listContainer
}

export const htmlLegendPlugin: Plugin = {
  id: 'htmlLegend',
  afterUpdate (chart, _args, options) {
    const ul = getOrCreateLegendList(chart, options.containerID)

    // Remove old legend items
    while (ul.firstChild) ul.firstChild.remove()

    // Reuse the built-in legendItems generator
    const items = chart.options.plugins?.legend?.labels?.generateLabels?.(chart)

    items?.forEach(item => {
      const dataset = chart.data.datasets[item.datasetIndex ?? 0] as
      ChartDataset<keyof ChartTypeRegistry, (number | [number, number] | Point | BubbleDataPoint | null)[]>
      & { provider: string, currency: 'BRL' | 'USD' | 'EUR', totalCosts: number, totalTasks: number, deleted: boolean }

      const li = document.createElement('li')
      li.className = `flex flex-col items-start cursor-pointer gap-1 hover:opacity-70 ${item.hidden ? 'opacity-40' : ''} pb-2 border-b border-gray-400 last:border-none last:pb-0`
      li.title = item.text

      li.onclick = () => {
        if ('type' in chart.config) {
          if (chart.config.type === 'pie' || chart.config.type === 'doughnut') {
            // Pie and doughnut charts only have a single dataset and visibility is per item
            chart.toggleDataVisibility(item.index ?? 0)
          } else {
            chart.setDatasetVisibility(item.datasetIndex ?? 0, !chart.isDatasetVisible(item.datasetIndex ?? 0))
          }
        }
        chart.update()
      }

      // Img
      const img = document.createElement('img')
      img.src = MAP_LOGO_BY_PROVIDER[dataset.provider as ProviderName] ?? ''
      img.className = 'w-5 h-5 rounded-md'

      // Color box
      const box = document.createElement('div')
      box.className = 'w-5 h-5 inline-block shrink-0 rounded-md'
      box.style.background = String(item.fillStyle)
      box.style.borderColor = String(item.strokeStyle)
      box.style.borderWidth = item.lineWidth + 'px'

      const div = document.createElement('div')
      div.className = 'flex gap-1 items-center'
      div.appendChild(img)
      div.appendChild(box)

      // Text
      const textContainer = document.createElement('span')
      textContainer.className = `m-0 p-0 truncate ${item.hidden ? 'line-through' : ''}`

      const text = document.createTextNode(item.text.length > 15 ? item.text.substring(0, 15).trim() + '...' : item.text)
      textContainer.appendChild(text)

      const wrapper = document.createElement('div')
      wrapper.className = 'flex gap-2'
      wrapper.appendChild(div)
      wrapper.appendChild(textContainer)

      // Value
      const totalCostDiv = document.createElement('div')
      totalCostDiv.className = 'text-sm flex flex-col'
      const span1 = document.createElement('span')
      const span2 = document.createElement('span')
      span1.appendChild(document.createTextNode(formatCurrency(dataset.currency, dataset.totalCosts)))
      span2.appendChild(document.createTextNode('Tasks: ' + formatTasks(dataset.totalTasks, 'compact')))
      span2.className = 'text-xs opacity-80'
      totalCostDiv.appendChild(span1)
      totalCostDiv.appendChild(span2)

      if (dataset.deleted) {
        const deletedDiv = document.createElement('div')
        deletedDiv.className = 'text-error text-xs font-mono'
        deletedDiv.textContent = 'Connection deleted'
        li.appendChild(deletedDiv)
      }

      // item
      li.appendChild(wrapper)
      li.appendChild(totalCostDiv)
      ul.appendChild(li)
    })
  }
}
